import { css } from "@emotion/react"

const breakpoints = {
  // Numerical values will result in a min-width query
  small: 480,
  medium: 768,
  large: 1024,
  xLarge: 1280,
  xxLarge: 1520,
  smallHeight: 490,
  ipad: 1069,
  // String values will be used as is
  tallPhone: "(max-width: 360px) and (min-height: 740px)",
}

export const queries = Object.keys(breakpoints).reduce((accumulator, label) => {
  if (typeof breakpoints[label] === "string") {
    accumulator[label] = (...args) =>
      css`
        @media (${breakpoints[label]}) {
          ${css(...args)};
        }
      `
  } else {
    if (label === "smallHeight") {
      accumulator[label] = (...args) =>
        css`
          @media (max-height: ${breakpoints[label]}px) {
            ${css(...args)};
          }
        `
    } else {
      accumulator[label] = (...args) =>
        css`
          @media (min-width: ${breakpoints[label]}px) {
            ${css(...args)};
          }
        `
    }
  }
  return accumulator
}, {})

// Use like this

// import { queries } from './mediaQueries.js`;
// const paragraph = css`
//   font-size: 12px;
//   ${queries.medium`
//     font-size: 14px;
//   `}
//   ${queries.large`
//     font-size: 16px;
//   `}
// `;
